import React from 'react';
import NavButton from '../common/NavButton';

function SideNavigation({ user, currentView, onViewChange, onBecomeCreator }) {
  return (
    <nav className="w-20 bg-white border-r border-gray-200 flex flex-col items-center py-6 space-y-8 fixed h-screen z-50">
      <h1 className="text-2xl font-heading font-bold text-primary mb-4" data-testid="app-logo">M</h1>
      
      <div className="flex-1 flex flex-col space-y-6">
        <NavButton
          icon="🏠"
          label="Feed"
          active={currentView === 'feed'}
          onClick={() => onViewChange('feed')}
          testId="nav-feed"
          vertical={true}
        />
        <NavButton
          icon="🔍"
          label="Discover"
          active={currentView === 'creators'}
          onClick={() => onViewChange('creators')}
          testId="nav-creators"
          vertical={true}
        />
        {user.role === 'creator' && (
          <NavButton
            icon="➕"
            label="Create"
            active={currentView === 'create'}
            onClick={() => onViewChange('create')}
            testId="nav-create"
            vertical={true}
          />
        )}
        <NavButton
          icon="📌"
          label="Saved"
          active={currentView === 'saved'}
          onClick={() => onViewChange('saved')}
          testId="nav-saved"
          vertical={true}
        />
        <NavButton
          icon="👤"
          label="Profile"
          active={currentView === 'profile'}
          onClick={() => onViewChange('profile')}
          testId="nav-profile"
          vertical={true}
        />
      </div>

      <div className="flex flex-col items-center gap-3">
        {user.role === 'follower' && (
          <button
            onClick={onBecomeCreator}
            className="text-xs bg-primary text-white px-2 py-2 rounded-button font-semibold hover:shadow-hover w-16 text-center"
            data-testid="become-creator-button"
            title="Become Creator"
          >
            ✨
          </button>
        )}
        <div className="w-10 h-10 rounded-full bg-primary flex items-center justify-center text-white font-bold" data-testid="user-avatar">
          {user.name?.charAt(0).toUpperCase()}
        </div>
      </div>
    </nav>
  );
}

export default SideNavigation;
